export default __webpack_public_path__ + "static/media/1347.8bb248cc.jpg";